import Actions from './display-container-actions';
import Api from './display-container-api';
import Collection from './display-container-collection';
import Model from './display-container-model';
import reducer from './display-container-reducer';
import sagas from './display-container-sagas';
import Selectors from './display-container-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'displayContainer',
  reducer,
  sagas:     [sagas],
  Selectors,
};
